// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"7":"b1d65c15","234":"a09a4364","832":"c5d45699","945":"6969cb3c"}[chunkId] + ".js";
};